import type { StarProps } from '@maestro/commerce-blocks/components/reviews/product-reviews.types'

import React from 'react'

import { Icon } from '@pearlconvert/ui/components/icon'

export default function Star({ fillType }: StarProps) {
  if (fillType === 'half') {
    return (
      <span className="review-stars__star--half">
        <Icon
          size="small"
          icon="star-empty"
          className="review-stars__star review-stars__star--empty"
        />
        <Icon
          size="small"
          icon="star-full"
          className="review-stars__star review-stars__star--star-full review-stars__star-fg"
        />
      </span>
    )
  }

  return (
    <Icon
      size="small"
      icon={fillType}
      className={`review-stars__star review-stars__star--${fillType}`}
    />
  )
}
